export default {
    employeeTable: {
        selected: [],
        search: '',
        headers: [
            {
                text: 'Name',
                align: 'start',
                sortable: true,
                value: 'name',
            },
            { text: 'Company', value: 'company' },
            { text: 'City', value: 'city' },
            { text: 'State', value: 'state' },
        ],
        employee: [
            {
                name: 'Joe James',
                company: 'Example Inc.',
                city: 'Yonkers',
                state: 'NY'
            },
            {
                name: 'John Walsh',
                company: 'Example Inc.',
                city: 'Hartford',
                state: 'CT'
            },
            {
                name: 'Bob Herm',
                company: 'Example Inc.',
                city: 'Tampa',
                state: 'FL'

            },
            {
                name: 'James Houston',
                company: 'Example Inc.',
                city: 'Dallas',
                state: 'TX'

            },
            {
                name: 'Prabhakar Linwood',
                company: 'Example Inc.',
                city: 'Hartford',
                state: 'CT'
            },
            {
                name: 'Jelly bean',
                company: 'Example Inc.',
                city: 'Yonkers',
                state: 'NY'
            },
            {
                name: 'Kaui Ignace',
                company: 'Example Inc.',
                city: 'Hartford',
                state: 'CT'
            },
            {
                name: 'Esperanza Susanne',
                company: 'Example Inc.',
                city: 'Tampa',
                state: 'FL'
            },
            {
                name: 'Christian Birgitte',
                company: 'Example Inc.',
                city: 'Hartford',
                state: 'CT'
            },
            {
                name: 'Meral Elias',
                company: 'Example Inc.',
                city: 'Yonkers',
                state: 'NY'
            },
            {
                name: 'Deep Pau',
                company: 'Example Inc.',
                city: 'Dallas',
                state: 'TX'
            },
            {
                name: 'Sebastiana Hani',
                company: 'Example Inc.',
                city: 'Yonkers',
                state: 'NY'
            },
            {
                name: 'Marciano Oihana',
                company: 'Example Inc.',
                city: 'Yonkers',
                state: 'TX'
            },
            {
                name: 'Brigid Ankur',
                company: 'Example Inc.',
                city: 'Dallas',
                state: 'NY'
            },
            {
                name: 'Anna Siranush',
                company: 'Example Inc.',
                city: 'Hartford',
                state: 'CT'
            },
            {
                name: 'Avram Sylva',
                company: 'Example Inc.',
                city: 'Tampa',
                state: 'FL'
            },
            {
                name: 'Serafima Babatunde',
                company: 'Example Inc.',
                city: 'Tampa',
                state: 'FL'
            },
            {
                name: 'Gaston Festus',
                company: 'Example Inc.',
                city: 'Yonkers',
                state: 'NY'
            },
        ],
    },
    materialUITable: [
        {
            id: 0,
            name: 'Mark Otto',
            avatar: {
                name: 'M',
                color: 'success'
            },
            email: 'ottoto@wxample.com',
            product: 'ON the Road',
            price: '$25 224.2',
            date: '11 May 2017',
            city: 'Otsego',
            status: 'Sent',
        },
        {
            id: 1,
            name: 'Jacob Thornton',
            avatar: {
                name: 'J',
                color: 'success'
            },
            email: 'thornton@wxample.com',
            product: 'HP Core i7',
            price: '$1 254.2',
            date: '4 Jun 2017',
            city: 'Fivepointville',
            status: 'Sent',
        },
        {
            id: 2,
            name: 'Larry the Bird',
            avatar: {
                name: 'L',
                color: 'warning'
            },
            email: 'bird@wxample.com',
            product: 'Air Pro',
            price: '$1 570.0',
            date: '27 Aug 2017',
            city: 'Leadville North',
            status: 'Pending',
        },
        {
            id: 3,
            name: 'Joseph May',
            avatar: {
                name: 'J',
                color: 'secondary'
            },
            email: 'josephmay@wxample.com',
            product: 'Version Control',
            price: '$5 224.5',
            date: '19 Feb 2018',
            city: 'Seaforth',
            status: 'Declined',
        },
        {
            id: 4,
            name: 'Peter Horadnia',
            avatar: {
                name: 'P',
                color: 'success'
            },
            email: 'horadnia@wxample.com',
            product: 'Let\'s Dance',
            price: '$43 594.7',
            date: '1 Mar 2018',
            city: 'Hanoverton',
            status: 'Sent',
        },
    ],
    menu: [
        'Edit',
        'Copy',
        'Delete',
        'Print'
    ]
}
